import React from "react"

import ApartmentInfo from "./ApartmentInfo";
import ApartmentDescription from "./ApartmentDescription";
import ApartmentPhotos from "./ApartmentPhotos";
import ApartmentServices from "./ApartmentServices";

import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";
import ApartmentPropertyInstruction from "./ApartmentPropertyInstruction";


const ApartmentTabs = () => {
    const [value, setValue] = React.useState("0");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return <Card sx={{mt: 3}}>
        <Box sx={{width: '100%', typography: 'body1'}}>
            <TabContext value={value}>
                <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                    <TabList onChange={handleChange}
                             aria-label="lab API tabs example"
                             variant="scrollable"
                             scrollButtons="auto">
                        <Tab label="Info" value="0"/>
                        <Tab label="Descrizione" value="1"/>
                        <Tab label="Foto Interne" value="2"/>
                        <Tab label="Servizi Appartamento" value="3"/>
                        <Tab label="Regole Ospiti" value="4"/>
                    </TabList>
                </Box>
                <TabPanel value="0" sx={{p: 0}}><ApartmentInfo/></TabPanel>
                <TabPanel value="1" sx={{p: 0}}><ApartmentDescription/></TabPanel>
                <TabPanel value="2" sx={{p: 0}}><ApartmentPhotos/></TabPanel>
                <TabPanel value="3" sx={{p: 0}}><ApartmentServices/></TabPanel>
                <TabPanel value="4" sx={{p: 0}}><ApartmentPropertyInstruction/></TabPanel>
            </TabContext>
        </Box>
    </Card>
}

export default ApartmentTabs;